<section class="lab-partners-section">
    <div class="container">

        <div class="partners-scroll-container">
            <div class="partners-grid">
                <div class="partner-card mt-2 mb-2" *ngFor="let partner of partners; trackBy: trackByPartner"
                    [attr.aria-label]="partner.name">
                    <div class="logo-container">
                        <img [src]="partner.logo" [alt]="partner.name + ' logo'" class="partner-logo" loading="lazy"
                            (click)="partner.website && openWebsite(partner.website)"
                            [class.clickable]="partner.website" />
                    </div>
                </div>
            </div>
        </div>

        <!-- Optional: Scroll indicators -->
        <div class="scroll-indicators">
            <button class="scroll-btn scroll-left" (click)="scrollLeft()" [disabled]="!canScrollLeft"
                aria-label="Scroll left">
                &#8249;
            </button>
            <button class="scroll-btn scroll-right" (click)="scrollRight()" [disabled]="!canScrollRight"
                aria-label="Scroll right">
                &#8250;
            </button>
        </div>
    </div>
</section>